






import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import PracticalExamForm from "@/views/Exam/PracticalExam/Exam/PracticalExamForm.vue";

@Component({
  components: {
    PracticalExamForm,
  },
})
export default class PracticalExamUpdate extends Vue {
  public name = "PracticalExamUpdate";

  @Prop()
  public exam: any;

  @Prop()
  public loading: any;

  @Inject("updatePracticalExam")
  protected updatePracticalExam: any;

  private onSubmit(exam: any): void {
    this.updatePracticalExam(exam);
  }

  private onClose(): void {
    this.$emit("on-close");
  }
}
